angular.module('picmonicng').directive('sharedPlaylistEmail', [
  '$modal',
  function ($modal) {
    return {
      restrict: 'A',
      scope: {
        playlist: '=',
      },
      link: function (scope, element, attrs) {
        element.bind('click', function (event) {
          scope.$apply(function () {
            $modal.open({
              templateUrl: '/templates/modals/shared-playlist-email.html',
              backdrop: true,
              controller: [
                '$scope',
                '$modalInstance',
                'Users',
                'Playlists',
                function ($scope, $modalInstance, Users, Playlists) {
                  $scope.playlist = scope.playlist;
                  $scope.selectedUsers = new Array();
                  $scope.EMAIL_REGEXP = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)+$/i;

                  $scope.close = function () {
                    $modalInstance.close();
                  };

                  $scope.runSearch = function (query) {
                    if (!$scope.loading) {
                      $scope.loading = true;
                      return Users.query({
                        query: query,
                        limit: 5,
                      }).$promise.finally(function () {
                        $scope.loading = false;
                      });
                    }
                  };

                  $scope.removeUser = function (user) {
                    $scope.selectedUsers = _.without($scope.selectedUsers, user);
                  };

                  $scope.addUser = function (user) {
                    if (!user) {
                      user = $scope.query;
                    }
                    if (typeof user == 'string') {
                      $scope.selectedUsers.push({
                        user_id: null,
                        username: user,
                      });
                    } else {
                      $scope.selectedUsers.push(user);
                    }
                    $scope.searchResults = new Array();
                    $scope.query = null;
                  };

                  $scope.share = function () {
                    $scope.loading = true;

                    var data = {
                      playlist_id: scope.playlist.playlist_id,
                      resource: 'shares',
                      type: 'users',
                      user_ids: new Array(),
                      emails: new Array(),
                    };

                    for (a in $scope.selectedUsers) {
                      if ($scope.selectedUsers[a].user_id) {
                        data.user_ids.push($scope.selectedUsers[a].user_id);
                      } else if ($scope.selectedUsers[a].username) {
                        data.emails.push($scope.selectedUsers[a].username);
                      }
                    }

                    send_ga('event', 'Playlist', 'Send Playlist');

                    Playlists.savev3(
                      data,
                      function () {
                        $scope.loading = false;
                        $scope.complete = true;
                      },
                      function () {
                        $scope.loading = false;
                      }
                    );
                  };
                },
              ],
            });
          });
        });
      },
    };
  },
]);
